var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"columns"},[_c('exam-card',{staticClass:"column"}),_c('div',{staticClass:"column"},[_c('surgery-card'),_c('document-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }